import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectApi } from '@socialive/common';
import { selectCurrentAccountId } from '../selectors';
import { setRolesLicensing } from '../slice';

export default createAsyncThunk('accountInfo/getRolesLicensing', async ({ trigger }, { dispatch, getState }) => {
  const api = selectApi(getState());
  if (!api) throw new Error('API is required');

  const accountId = selectCurrentAccountId(getState());

  const response = await api(`/v1/accounts/${accountId}/licenses?type=roles`, { silentError: true });
  const { licenseId, licenseData } = response;

  await dispatch(setRolesLicensing({ licenseId, licenseData, trigger }));

  return response;
});
